{
  "voice": "Zeus Epic",
  "fallbackVoice": "David - Movie Trailer Narrator",
  "style": 0.7,
  "groups": [
    {
      "id": "welcome",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Welcome, apprentices, to Wizard Arena: Total Mayhem! Cast fast, blast faster, and try to die somewhere the cameras can see you.", "caption": "WELCOME TO WIZARD ARENA: TOTAL MAYHEM!" },
        { "text": "Welcome to Wizard Arena! I am Archmage Vaelen, your host, your judge, and the only one here with a return ticket. Gates are locked. Begin!", "caption": "I AM ARCHMAGE VAELEN. GATES ARE LOCKED. BEGIN!" },
        { "text": "Ladies, gentlemen, and whatever crawled out of the last portal! Wizard Arena is OPEN. Try to last longer than the opening credits!", "caption": "WIZARD ARENA IS OPEN. OUTLAST THE CREDITS." },
        { "text": "Fresh meat! I mean, honored guests. Same thing. Wands up, dignity down, and smile for the scrying orbs!", "caption": "FRESH MEAT! WANDS UP, DIGNITY DOWN." },
        { "text": "Robes on. Brains optional. Wizard Arena begins!", "caption": "ROBES ON. BRAINS OPTIONAL." },
        { "text": "Tonight's contestant: you. Tonight's mop: also you.", "caption": "TONIGHT'S CONTESTANT: YOU. TONIGHT'S MOP: ALSO YOU." }
      ]
    },
    {
      "id": "opening",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "The gates are locked! Begin!", "caption": "GATES ARE LOCKED. BEGIN!" },
        { "text": "Gates locked. Nobody leaves pretty.", "caption": "GATES LOCKED. NOBODY LEAVES PRETTY." },
        { "text": "Locks turned. Go make a mess.", "caption": "LOCKS TURNED. GO MAKE A MESS." },
        { "text": "Doors sealed! Curtain up, apprentice!", "caption": "DOORS SEALED! CURTAIN UP!" },
        { "text": "The gates are shut. Your fate isn't.", "caption": "GATES SHUT. YOUR FATE ISN'T." },
        { "text": "Bolted tight. Begin, and be loud about it.", "caption": "BOLTED TIGHT. BE LOUD ABOUT IT." }
      ]
    },
    {
      "id": "room_enter",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Gates down! Portals up! Kill everything and make it look good!", "caption": "GATES DOWN! PORTALS UP!" },
        { "text": "New room, same smell. Somebody light a candle. Preferably an imp.", "caption": "NEW ROOM, SAME SMELL. LIGHT AN IMP." },
        { "text": "Another chamber, another chance to embarrass the entire wizarding profession. Go on.", "caption": "ANOTHER CHANCE TO EMBARRASS WIZARDRY. GO ON." },
        { "text": "The portals are hungry and you are the buffet. Shoot back, it's only polite.", "caption": "YOU ARE THE BUFFET. SHOOT BACK." },
        { "text": "Ooh, this room has excellent acoustics. Perfect for screaming!", "caption": "EXCELLENT ACOUSTICS. PERFECT FOR SCREAMING!" },
        { "text": "Fresh room. Same bad plan?", "caption": "FRESH ROOM. SAME BAD PLAN?" },
        { "text": "In you go. Mind the teeth.", "caption": "IN YOU GO. MIND THE TEETH." }
      ]
    },
    {
      "id": "treasure_room",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "A treasure vault! Grab it all, you greedy little cauldron goblin. I'm not judging. I am, but quietly.", "caption": "TREASURE VAULT! GRAB IT ALL, GOBLIN." },
        { "text": "Gold on the floor, and only a few things trying to eat you. It's practically a spa.", "caption": "GOLD ON THE FLOOR. PRACTICALLY A SPA." },
        { "text": "A vault! The gold is real, the safety is theoretical. Shop with your feet, apprentice.", "caption": "THE GOLD IS REAL. THE SAFETY IS THEORETICAL." },
        { "text": "Treasure room! Fill your pockets before something fills you with holes. Balance, that's the trick.", "caption": "FILL YOUR POCKETS BEFORE THEY FILL YOU WITH HOLES." },
        { "text": "A vault! Loot first, breathe later.", "caption": "A VAULT! LOOT FIRST, BREATHE LATER." },
        { "text": "Gold everywhere. Try not to bleed on it.", "caption": "GOLD EVERYWHERE. DON'T BLEED ON IT." },
        { "text": "Treasure! Greed is a virtue here. So is ducking.", "caption": "GREED IS A VIRTUE HERE. SO IS DUCKING." }
      ]
    },
    {
      "id": "hazard_room",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Hazard pit! Extra portals, extra imps, extra paperwork for whoever finds the body.", "caption": "HAZARD PIT! EXTRA EVERYTHING." },
        { "text": "You chose the hazard door. Bold. Stupid, but bold. I respect it from a safe distance.", "caption": "BOLD. STUPID. I RESPECT IT FROM A DISTANCE." },
        { "text": "Hazard door! Congratulations, you picked the room that hates you specifically.", "caption": "YOU PICKED THE ROOM THAT HATES YOU SPECIFICALLY." },
        { "text": "Oh, this one's spicy. Extra portals, extra teeth, extra reasons to write a will.", "caption": "EXTRA PORTALS, EXTRA TEETH. WRITE A WILL." },
        { "text": "Hazard room. Insurance won't cover this.", "caption": "HAZARD ROOM. INSURANCE WON'T COVER THIS." },
        { "text": "Extra portals, extra imps, extra you? No. Still just one of you.", "caption": "EXTRA EVERYTHING. STILL JUST ONE OF YOU." },
        { "text": "Hazard door. The room was hoping you'd pick it.", "caption": "THE ROOM WAS HOPING YOU'D PICK IT." }
      ]
    },
    {
      "id": "new_threat_skull",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Screamer skulls! They hover, they wind up, then they bite your face. Don't let them finish the scream.", "caption": "SCREAMER SKULLS! DON'T LET THEM WIND UP!" },
        { "text": "Oh good, skulls. Fast little lungers. One dart and your robe has a new ventilation hole.", "caption": "SKULLS! FAST LITTLE LUNGERS." },
        { "text": "Skulls! All bite, no brain. Familiar?", "caption": "SKULLS! ALL BITE, NO BRAIN. FAMILIAR?" },
        { "text": "Screamer skulls! Shut them up before they finish.", "caption": "SHUT THEM UP BEFORE THEY FINISH." },
        { "text": "Flying teeth incoming. Duck, apprentice.", "caption": "FLYING TEETH INCOMING. DUCK." },
        { "text": "Skulls in the air! Nobody told them they're dead.", "caption": "SKULLS! NOBODY TOLD THEM THEY'RE DEAD." }
      ]
    },
    {
      "id": "new_threat_slime",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Hex slimes! Fat, hoppy, and they do not go down easy. Aim for the wobble!", "caption": "HEX SLIMES! AIM FOR THE WOBBLE!" },
        { "text": "Slimes! They hop, they bounce, they soak up a wand-full. Somebody bring a mop.", "caption": "SLIMES! THEY SOAK UP A WAND-FULL." },
        { "text": "Slimes! Squishy, stubborn, and they stain.", "caption": "SLIMES! SQUISHY, STUBBORN, THEY STAIN." },
        { "text": "Hex slimes! Shoot the wobble till it stops.", "caption": "SHOOT THE WOBBLE TILL IT STOPS." },
        { "text": "Slime pack! Bring a mop and a grudge.", "caption": "SLIME PACK! BRING A MOP AND A GRUDGE." },
        { "text": "Slimes! They take more punishment than your robe does.", "caption": "SLIMES! THEY TAKE MORE PUNISHMENT THAN YOUR ROBE." }
      ]
    },
    {
      "id": "new_threat_bat",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Rune bats! They circle like they own the place, then they dive. They do not own the place.", "caption": "RUNE BATS! THEY CIRCLE, THEN THEY DIVE!" },
        { "text": "Bats! Pretty orbits, ugly landings. Shoot them before they pick a wizard and commit.", "caption": "BATS! SHOOT THEM BEFORE THEY COMMIT." },
        { "text": "Bats! Orbit, dive, regret. Shoot early.", "caption": "BATS! ORBIT, DIVE, REGRET." },
        { "text": "Rune bats! They flirt, then they bite.", "caption": "RUNE BATS! THEY FLIRT, THEN THEY BITE." },
        { "text": "Bats incoming. Watch the swoop, not the wings.", "caption": "WATCH THE SWOOP, NOT THE WINGS." },
        { "text": "Bats! Flying rats with ambition.", "caption": "BATS! FLYING RATS WITH AMBITION." }
      ]
    },
    {
      "id": "new_threat_hexer",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Imp hexers! The first fiends down here with the sense to stand back and throw things. Close the gap or eat the bolt.", "caption": "IMP HEXERS! CLOSE THE GAP OR EAT THE BOLT." },
        { "text": "Hexers! They keep their distance and lob curses. Cowardly. Effective. Kill them first.", "caption": "HEXERS! COWARDLY. EFFECTIVE. KILL THEM FIRST." },
        { "text": "Look at that, an imp learned a spell. Now it's your problem.", "caption": "AN IMP LEARNED A SPELL. NOW IT'S YOUR PROBLEM." },
        { "text": "Hexers on the floor! They wind up before they throw. That wind-up is your invitation.", "caption": "HEXERS! THE WIND-UP IS YOUR INVITATION." },
        { "text": "Imps with wands. I know. I'm as offended as you are.", "caption": "IMPS WITH WANDS. I'M AS OFFENDED AS YOU ARE." }
      ]
    },
    {
      "id": "new_threat_cinder",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Cinder skulls! They only go one direction, and it's at you, and then they explode. Do not hug them.", "caption": "CINDER SKULLS! THEY EXPLODE. DO NOT HUG THEM." },
        { "text": "Cinders! Walking fireworks with a grudge. Pop them at range or wear the blast.", "caption": "CINDERS! POP THEM AT RANGE OR WEAR THE BLAST." },
        { "text": "Cinder skulls on the floor. They get faster the longer they chase. Stop letting them chase.", "caption": "CINDERS GET FASTER THE LONGER THEY CHASE." },
        { "text": "Skulls that burst! Fun fact: they take their friends with them. Use that.", "caption": "CINDERS TAKE THEIR FRIENDS WITH THEM. USE THAT." },
        { "text": "Cinders! Shoot the fuse, not the flame.", "caption": "CINDERS! SHOOT THE FUSE, NOT THE FLAME." }
      ]
    },
    {
      "id": "new_threat_blight",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Blight slimes! Big, slow, and when they pop they become two smaller problems. The maths is not in your favor.", "caption": "BLIGHT SLIMES! ONE POPS INTO TWO. BAD MATHS." },
        { "text": "Blights! Every one you kill leaves a pair behind. Kill the pair faster than the one.", "caption": "BLIGHTS! KILL THE PAIR FASTER THAN THE ONE." },
        { "text": "Purple slimes. Heavy. Splitty. Bring a mop and a plan.", "caption": "BLIGHTS! BRING A MOP AND A PLAN." },
        { "text": "Blight slimes! They hop like hammers and die like hydras.", "caption": "THEY HOP LIKE HAMMERS AND DIE LIKE HYDRAS." },
        { "text": "Blights on the floor. Don't pop one in a corner unless you enjoy company.", "caption": "DON'T POP A BLIGHT IN A CORNER." }
      ]
    },
    {
      "id": "new_threat_wraith",
      "priority": 2,
      "cooldown": 0,
      "variants": [
        { "text": "Hollow wraiths! They fade, they reappear behind you, they lunge. Shoot them while they're solid or don't bother.", "caption": "WRAITHS! SHOOT THEM WHILE THEY'RE SOLID." },
        { "text": "Wraiths! You can't hit what isn't there. Wait for the reform, then make it very there.", "caption": "WRAITHS! WAIT FOR THE REFORM." },
        { "text": "Something just blinked behind you. Wraiths. Keep moving and they miss.", "caption": "WRAITHS BLINK BEHIND YOU. KEEP MOVING." },
        { "text": "Hollow wraiths! They flank. Rude, really. Turn around more.", "caption": "WRAITHS FLANK. TURN AROUND MORE." },
        { "text": "Wraiths on the floor. Ghosts with a schedule: drift, vanish, stab.", "caption": "WRAITHS: DRIFT, VANISH, STAB." }
      ]
    },
    {
      "id": "arena_room",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "The Champion's Ring! No portals, no warm-up. Just you and tonight's headliner. Places, everyone!", "caption": "CHAMPION'S RING! NO PORTALS. JUST THE HEADLINER." },
        { "text": "Ah, the Ring. The sponsors love this room. One wizard, one champion, one very short conversation.", "caption": "THE RING. ONE WIZARD. ONE CHAMPION." },
        { "text": "Champion's Ring! It pays better than a portal room. It also ends faster. Usually for you.", "caption": "THE RING PAYS BETTER. IT ALSO ENDS FASTER." },
        { "text": "No fiends tonight. Just the one big one. Try to look surprised when it lands.", "caption": "NO FIENDS. JUST THE ONE BIG ONE." },
        { "text": "The Ring! Straight to the main event. I've cleared my schedule.", "caption": "THE RING! STRAIGHT TO THE MAIN EVENT." }
      ]
    },
    {
      "id": "gauntlet_room",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "The Gargoyle Gallery! Every wall has an opinion and every opinion is a bolt. Keep moving, apprentice.", "caption": "GARGOYLE GALLERY! EVERY WALL HAS A BOLT FOR YOU." },
        { "text": "A gallery of guns. Stand still and they'll draw your portrait in acid.", "caption": "STAND STILL AND THEY'LL DRAW YOUR PORTRAIT IN ACID." },
        { "text": "Gauntlet room! One portal, a dozen stone critics. Sidestep like your life depends on it. It does.", "caption": "ONE PORTAL. A DOZEN STONE CRITICS. SIDESTEP." },
        { "text": "The Gallery! The walls shoot back here. I did mention the walls, didn't I?", "caption": "THE WALLS SHOOT BACK HERE." },
        { "text": "Gargoyles everywhere. Cross-fire is an art form and you are the canvas.", "caption": "CROSS-FIRE IS AN ART FORM. YOU ARE THE CANVAS." }
      ]
    },
    {
      "id": "sanctum_room",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A sanctum. No fiends, no portals, no cameras. Well, one camera. Take a breath, you've earned about half of one.", "caption": "A SANCTUM. TAKE A BREATH. YOU'VE EARNED HALF OF ONE." },
        { "text": "Rest room! Not that kind. Heart on the floor, gold in the corners, nothing trying to kill you for once.", "caption": "SANCTUM! NOTHING TRYING TO KILL YOU. FOR ONCE." },
        { "text": "A quiet room. The sponsors hate these. I rather like watching you pretend to relax.", "caption": "A QUIET ROOM. PRETEND TO RELAX." },
        { "text": "Sanctum. Heal up, stock up, and don't get used to it.", "caption": "SANCTUM. HEAL UP. DON'T GET USED TO IT." },
        { "text": "Peace and quiet. Unsettling, isn't it? Grab the heart and go.", "caption": "PEACE AND QUIET. UNSETTLING. GRAB THE HEART." }
      ]
    },
    {
      "id": "mimic_wake",
      "priority": 4,
      "cooldown": 4,
      "variants": [
        { "text": "That chest has teeth! Mimic! I did say greed was a virtue. I lied.", "caption": "MIMIC! THAT CHEST HAS TEETH!" },
        { "text": "Surprise! The gold was bait. The chest is hungry. Shoot the chest.", "caption": "THE GOLD WAS BAIT. SHOOT THE CHEST." },
        { "text": "A mimic! Oh, the sponsors will replay this one all week.", "caption": "A MIMIC! THE SPONSORS WILL REPLAY THIS ALL WEEK." },
        { "text": "Never trust a chest that doesn't blink. Mimic!", "caption": "NEVER TRUST A CHEST THAT DOESN'T BLINK." },
        { "text": "Mimic! It hops. It bites. It still has the gold inside, if that helps.", "caption": "MIMIC! IT STILL HAS THE GOLD INSIDE." }
      ]
    },
    {
      "id": "mimic_slain",
      "priority": 3,
      "cooldown": 4,
      "variants": [
        { "text": "Chest busted! And look, it really was full of gold. Pick it up before something else does.", "caption": "CHEST BUSTED! IT REALLY WAS FULL OF GOLD." },
        { "text": "Mimic down. Furniture: zero. Wizard: one.", "caption": "MIMIC DOWN. FURNITURE ZERO, WIZARD ONE." },
        { "text": "You killed a box. A very bitey box. The gold is your apology.", "caption": "YOU KILLED A VERY BITEY BOX. HERE'S YOUR GOLD." },
        { "text": "The chest is dead. Long live the gold.", "caption": "THE CHEST IS DEAD. LONG LIVE THE GOLD." }
      ]
    },
    {
      "id": "brute_down",
      "priority": 2,
      "cooldown": 6,
      "variants": [
        { "text": "Brute down! All that charging and it never once looked where it was going.", "caption": "BRUTE DOWN! NEVER LOOKED WHERE IT WAS GOING." },
        { "text": "The ember brute is out. Somebody sweep up the coals.", "caption": "EMBER BRUTE OUT. SWEEP UP THE COALS." },
        { "text": "Brute flattened! It hit the wall harder than it ever hit you. Poetry.", "caption": "IT HIT THE WALL HARDER THAN IT HIT YOU." },
        { "text": "Brute down. Big, fast, stupid. Two out of three is still a loss.", "caption": "BRUTE DOWN. BIG, FAST, STUPID." }
      ]
    },
    {
      "id": "brute_wall",
      "priority": 1,
      "cooldown": 7,
      "variants": [
        { "text": "Straight into the wall. Every time. Shoot it while it counts its teeth.", "caption": "INTO THE WALL. SHOOT IT WHILE IT COUNTS ITS TEETH." },
        { "text": "The brute has met the masonry. The masonry won.", "caption": "THE BRUTE MET THE MASONRY. THE MASONRY WON." },
        { "text": "Dazed! Now, apprentice. Now!", "caption": "DAZED! NOW, APPRENTICE. NOW!" }
      ]
    },
    {
      "id": "floor_mod_swarm",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Tonight's floor rule: SWARM. The portals cough bigger and the fiends come thinner. Quantity has a quality of its own.", "caption": "FLOOR RULE: SWARM. BIGGER PACKS, THINNER SKINS." },
        { "text": "Sponsor rule for this floor: Swarm! More of everything, and everything is slightly cheaper. Like the sponsor.", "caption": "SWARM! MORE OF EVERYTHING, SLIGHTLY CHEAPER." },
        { "text": "Swarm floor! If you can't see the flagstones, you're doing it right.", "caption": "SWARM FLOOR! IF YOU CAN'T SEE THE FLOOR, GOOD." }
      ]
    },
    {
      "id": "floor_mod_fortified",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Floor rule: FORTIFIED. Fewer portals, more gargoyles, and the walls have opinions about where you stand.", "caption": "FLOOR RULE: FORTIFIED. THE WALLS HAVE TEETH." },
        { "text": "This floor is Fortified! The masons went overboard and every ledge got a gun. Keep dancing.", "caption": "FORTIFIED! EVERY LEDGE GOT A GUN." },
        { "text": "Fortified floor. The portals are thin, the walls are not. Choose your corners with care.", "caption": "FORTIFIED. THIN PORTALS, THICK WALLS." }
      ]
    },
    {
      "id": "floor_mod_haste",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Floor rule: HASTE. Everything down here is in a hurry, and none of it is late for anything but you.", "caption": "FLOOR RULE: HASTE. EVERYTHING IS IN A HURRY." },
        { "text": "Haste floor! The fiends had their coffee. Did you?", "caption": "HASTE! THE FIENDS HAD THEIR COFFEE. DID YOU?" },
        { "text": "This floor runs fast. Aim ahead. Then aim further ahead.", "caption": "HASTE. AIM AHEAD. THEN FURTHER AHEAD." }
      ]
    },
    {
      "id": "floor_mod_bounty",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Floor rule: BOUNTY! Every kill sheds gold and the prize waves are fat. The sponsors are feeling generous. Suspicious, but generous.", "caption": "FLOOR RULE: BOUNTY. EVERY KILL PAYS." },
        { "text": "Bounty floor! The fiends are carrying gems. Extract them. Loudly.", "caption": "BOUNTY! THE FIENDS ARE CARRYING GEMS. EXTRACT THEM." },
        { "text": "This floor pays double. Greed is not a sin here. It's a strategy.", "caption": "BOUNTY. GREED IS A STRATEGY." }
      ]
    },
    {
      "id": "floor_mod_elite",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Floor rule: ELITE. The portals send heavies twice as often, and the brutes have come down early. Legs, apprentice. Use them.", "caption": "FLOOR RULE: ELITE. HEAVIES TWICE AS OFTEN." },
        { "text": "Elite floor! Golems, brutes, and very little patience. Aim for the big ones. They're easy to find.", "caption": "ELITE! AIM FOR THE BIG ONES." },
        { "text": "This floor is Elite. That's a word for heavy. Everything is heavy.", "caption": "ELITE. THAT'S A WORD FOR HEAVY." }
      ]
    },
    {
      "id": "floor_mod_restless",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Floor rule: RESTLESS. Cinderwyrm is already circling and she has never once waited politely. Work fast.", "caption": "FLOOR RULE: RESTLESS. THE WYRM IS CIRCLING." },
        { "text": "Restless floor! My dragon is bored. Bored dragons are a scheduling hazard. Move.", "caption": "RESTLESS. MY DRAGON IS BORED. MOVE." },
        { "text": "The wyrm's timer is short on this floor. Shorter than your attention span, so keep up.", "caption": "RESTLESS. THE WYRM'S TIMER IS SHORT." }
      ]
    },
    {
      "id": "floor_mod_haunted",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Floor rule: HAUNTED. Hollow wraiths ride with every pack tonight. If you feel a chill behind you, that's not the draught.", "caption": "FLOOR RULE: HAUNTED. WRAITHS RIDE WITH EVERY PACK." },
        { "text": "Haunted floor! Every portal comes with a ghost. Complimentary. Non-refundable.", "caption": "HAUNTED! EVERY PORTAL COMES WITH A GHOST." },
        { "text": "This floor is Haunted. Something will appear behind you. Repeatedly. Turn around.", "caption": "HAUNTED. TURN AROUND. REPEATEDLY." }
      ]
    },
    {
      "id": "room_clear",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "Room cleared! Pick a door, and pick it quickly, the sponsors are watching.", "caption": "ROOM CLEARED! PICK A DOOR!" },
        { "text": "Cleared! Not bad. My grandmother did it faster, and she's a portrait.", "caption": "CLEARED! GRANDMOTHER WAS FASTER. SHE'S A PORTRAIT." },
        { "text": "Room clear! Look at you, alive and everything. Don't get cocky, the next one has doors too.", "caption": "ROOM CLEAR! DON'T GET COCKY." },
        { "text": "And the room is empty! Except for the goo. So much goo. Housekeeping!", "caption": "EMPTY! EXCEPT THE GOO. HOUSEKEEPING!" },
        { "text": "Cleared! Choose your exit. One of them is worse. I won't say which. It's more fun this way.", "caption": "CHOOSE YOUR EXIT. ONE OF THEM IS WORSE." },
        { "text": "Clear! Lovely mess.", "caption": "CLEAR! LOVELY MESS." },
        { "text": "Room's empty. Pick a door, not a nose.", "caption": "PICK A DOOR, NOT A NOSE." },
        { "text": "Cleared! The goo approves.", "caption": "CLEARED! THE GOO APPROVES." }
      ]
    },
    {
      "id": "portal_down",
      "priority": 2,
      "cooldown": 10,
      "variants": [
        { "text": "Portal down! Beautiful! Do it again!", "caption": "PORTAL DOWN! DO IT AGAIN!" },
        { "text": "Portal shattered! That's coming out of somebody's deposit.", "caption": "PORTAL SHATTERED! OUT OF THE DEPOSIT." },
        { "text": "Another portal gone! You're ruining a perfectly good infestation.", "caption": "RUINING A PERFECTLY GOOD INFESTATION." },
        { "text": "Portal down! Somewhere a demon lord just got a very disappointing email.", "caption": "A DEMON LORD JUST GOT A DISAPPOINTING EMAIL." },
        { "text": "Portal popped! Somebody's rent just went up.", "caption": "PORTAL POPPED! RENT JUST WENT UP." },
        { "text": "Portal gone! Keep breaking my things.", "caption": "PORTAL GONE! KEEP BREAKING MY THINGS." },
        { "text": "Crack! One less hole in the world.", "caption": "CRACK! ONE LESS HOLE IN THE WORLD!" },
        { "text": "That's gotta hurt! For the portal! Keep cracking!", "caption": "THAT'S GOTTA HURT! FOR THE PORTAL!" },
        { "text": "Portal down! The infestation just lost a door.", "caption": "THE INFESTATION JUST LOST A DOOR." }
      ]
    },
    {
      "id": "last_portal",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "LAST PORTAL! Finish the leftovers!", "caption": "LAST PORTAL! FINISH THE LEFTOVERS!" },
        { "text": "One portal left! Don't choke now, the whole realm is watching you not choke.", "caption": "ONE PORTAL LEFT! DON'T CHOKE!" },
        { "text": "Final portal! Kill it and I'll pretend the first thirty seconds never happened.", "caption": "FINAL PORTAL! I'LL PRETEND YOU WERE GOOD." },
        { "text": "Last portal! Kill the leftovers!", "caption": "LAST PORTAL! KILL THE LEFTOVERS!" },
        { "text": "One portal left. Make it hurt.", "caption": "ONE PORTAL LEFT. MAKE IT HURT." },
        { "text": "Final portal! Don't get shy now.", "caption": "FINAL PORTAL! DON'T GET SHY NOW." },
        { "text": "One to go. The crowd wants a splash.", "caption": "ONE TO GO. THE CROWD WANTS A SPLASH." }
      ]
    },
    {
      "id": "heal_expensive",
      "priority": 2,
      "cooldown": 7,
      "variants": [
        { "text": "Ooh! THAT looked expensive to heal!", "caption": "THAT LOOKED EXPENSIVE TO HEAL!" },
        { "text": "Ouch! Right in the apprentice! Walk it off. Or crawl. Crawling counts.", "caption": "RIGHT IN THE APPRENTICE! CRAWLING COUNTS." },
        { "text": "Oh, that's going to leave a mark. Several marks. A whole constellation of marks.", "caption": "A WHOLE CONSTELLATION OF MARKS." },
        { "text": "You do know the imps are supposed to hit the OTHER wizard, right? Oh. There isn't one. Awkward.", "caption": "THEY'RE MEANT TO HIT THE OTHER WIZARD. AWKWARD." },
        { "text": "Yikes! Your robe is more hole than robe. Very breezy. Very fatal.", "caption": "MORE HOLE THAN ROBE. VERY BREEZY. VERY FATAL." },
        { "text": "That hit had feelings. All of them yours.", "caption": "THAT HIT HAD FEELINGS. ALL OF THEM YOURS." },
        { "text": "Bones make that noise? Apparently.", "caption": "BONES MAKE THAT NOISE? APPARENTLY." },
        { "text": "That's gotta hurt! I felt that from the booth!", "caption": "THAT'S GOTTA HURT! I FELT THAT FROM THE BOOTH!" },
        { "text": "Oof! The sponsors winced. That's a first.", "caption": "THE SPONSORS WINCED. THAT'S A FIRST." },
        { "text": "That's a bruise with a name on it. Yours.", "caption": "A BRUISE WITH A NAME ON IT. YOURS." }
      ]
    },
    {
      "id": "near_death",
      "priority": 4,
      "cooldown": 12,
      "variants": [
        { "text": "You're on your last spark, apprentice! Either heal up or start composing your final words. Keep them short, we have a schedule.", "caption": "LAST SPARK! KEEP THE FINAL WORDS SHORT." },
        { "text": "Health critical! I've seen ghosts with more color in their cheeks. Move!", "caption": "GHOSTS HAVE MORE COLOR. MOVE!" },
        { "text": "Ooh, one more tickle and you're a fine mist. The mop is standing by.", "caption": "ONE MORE TICKLE AND YOU'RE A MIST." },
        { "text": "One hit from a headline! Heal, apprentice!", "caption": "ONE HIT FROM A HEADLINE! HEAL!" },
        { "text": "You're a rumor with legs. Find a heart!", "caption": "A RUMOR WITH LEGS. FIND A HEART!" },
        { "text": "Health gone, hope going. Run!", "caption": "HEALTH GONE, HOPE GOING. RUN!" },
        { "text": "Last drop of blood. Spend it wisely.", "caption": "LAST DROP OF BLOOD. SPEND IT WISELY." }
      ]
    },
    {
      "id": "kill_streak",
      "priority": 3,
      "cooldown": 8,
      "variants": [
        { "text": "TOTAL MAYHEM! That's the stuff! Keep painting the walls!", "caption": "TOTAL MAYHEM! KEEP PAINTING THE WALLS!" },
        { "text": "Look at that combo! Ha! It's like a blender learned magic!", "caption": "LIKE A BLENDER LEARNED MAGIC!" },
        { "text": "Kill streak! Somebody is showing off, and for once it isn't me!", "caption": "KILL STREAK! SHOWING OFF!" },
        { "text": "Magnificent carnage! Ten more and I'll name a puddle after you.", "caption": "TEN MORE AND I'LL NAME A PUDDLE AFTER YOU." },
        { "text": "Streak! Somebody's angry at the furniture!", "caption": "STREAK! ANGRY AT THE FURNITURE!" },
        { "text": "Twenty in a blink! The mops are unionizing!", "caption": "TWENTY IN A BLINK! THE MOPS ARE UNIONIZING!" },
        { "text": "Now THAT'S a smoothie!", "caption": "NOW THAT'S A SMOOTHIE!" },
        { "text": "Combo! The imps are filing complaints!", "caption": "COMBO! THE IMPS ARE FILING COMPLAINTS!" },
        { "text": "That's gotta hurt! For them! Keep blending!", "caption": "THAT'S GOTTA HURT! FOR THEM! KEEP BLENDING!" },
        { "text": "Mayhem meter: overflowing! Don't stop now!", "caption": "MAYHEM METER: OVERFLOWING!" },
        { "text": "They're dropping like cursed laundry! Beautiful!", "caption": "DROPPING LIKE CURSED LAUNDRY! BEAUTIFUL!" }
      ]
    },
    {
      "id": "gem_greed",
      "priority": 2,
      "cooldown": 20,
      "variants": [
        { "text": "Gems, gems, gems! Someone's got a dragon's appetite and a hamster's bank account.", "caption": "A DRAGON'S APPETITE, A HAMSTER'S BANK ACCOUNT." },
        { "text": "Look at you, hoovering up loot mid-battle. Priorities! Terrible ones, but priorities!", "caption": "HOOVERING LOOT MID-BATTLE. PRIORITIES!" },
        { "text": "You're collecting rocks while on fire. I would applaud, but I'm busy taking notes for your eulogy.", "caption": "COLLECTING ROCKS WHILE ON FIRE. NOTED FOR THE EULOGY." },
        { "text": "Mana gems! Beautiful, shiny, and absolutely not a substitute for not dying.", "caption": "SHINY. NOT A SUBSTITUTE FOR NOT DYING." },
        { "text": "Gem goblin! Pockets before pulse!", "caption": "GEM GOBLIN! POCKETS BEFORE PULSE!" },
        { "text": "Loot first, live later. Bold budgeting.", "caption": "LOOT FIRST, LIVE LATER. BOLD BUDGETING." }
      ]
    },
    {
      "id": "heal",
      "priority": 1,
      "cooldown": 12,
      "variants": [
        { "text": "A rune heart! Blood back in the body, dignity still missing.", "caption": "RUNE HEART! BLOOD BACK, DIGNITY STILL MISSING." },
        { "text": "Ooh, a heart. Somebody's finally learned to bleed responsibly.", "caption": "A HEART. BLEED RESPONSIBLY." },
        { "text": "Patched up. Try to keep that inside you this time.", "caption": "PATCHED UP. KEEP IT INSIDE THIS TIME." },
        { "text": "Healing! Don't get used to it, the hearts are on loan.", "caption": "HEALING! THE HEARTS ARE ON LOAN." },
        { "text": "Heart acquired! The blood's going back where it belongs. For now.", "caption": "BLOOD'S GOING BACK WHERE IT BELONGS. FOR NOW." },
        { "text": "A refill! Don't spend it all in one bite. The imps have ideas.", "caption": "A REFILL! THE IMPS HAVE IDEAS." },
        { "text": "Heart in. Try to deserve it.", "caption": "HEART IN. TRY TO DESERVE IT." }
      ]
    },
    {
      "id": "supply_weapon",
      "priority": 2,
      "cooldown": 8,
      "variants": [
        { "text": "Special delivery from the armory! Something big is floating in through the gate. Go fetch, wizard.", "caption": "SPECIAL DELIVERY! SOMETHING BIG IS FLOATING IN." },
        { "text": "Incoming! An Epic Weapon drifting in, gift-wrapped in sparkles. Try not to drop it.", "caption": "INCOMING! EPIC WEAPON, GIFT-WRAPPED." },
        { "text": "The sponsors sent a toy. Catch it before an imp learns to read the instructions.", "caption": "THE SPONSORS SENT A TOY. CATCH IT." },
        { "text": "Weapon on the floor! Yes, floating counts as the floor, don't argue with the host.", "caption": "WEAPON ON THE FLOOR! DON'T ARGUE WITH THE HOST." },
        { "text": "Care package! The armory coughed something up. It's drifting in like it owns the place.", "caption": "THE ARMORY COUGHED SOMETHING UP. GO CLAIM IT." },
        { "text": "Ooh, a present! Big, glowy, and almost certainly louder than your wand. Fetch!", "caption": "A PRESENT! LOUDER THAN YOUR WAND. FETCH!" },
        { "text": "Big toy inbound! Grab it before it grabs you.", "caption": "BIG TOY INBOUND! GRAB IT FIRST." }
      ]
    },
    {
      "id": "supply_heart",
      "priority": 2,
      "cooldown": 10,
      "variants": [
        { "text": "You look awful. Here, a rune heart is drifting in. Consider it pity with a pulse.", "caption": "YOU LOOK AWFUL. HAVE SOME PITY WITH A PULSE." },
        { "text": "Medical wizardry incoming through the gate! Limp faster.", "caption": "MEDICAL WIZARDRY INCOMING! LIMP FASTER." },
        { "text": "A heart floats in. The crowd voted to keep you alive. It was close.", "caption": "THE CROWD VOTED TO KEEP YOU ALIVE. IT WAS CLOSE." },
        { "text": "Emergency snack for your bloodstream, incoming. Don't trip over the help.", "caption": "EMERGENCY SNACK FOR YOUR BLOODSTREAM." },
        { "text": "They're sending you a heart. I'd call it kindness, but I billed the sponsors.", "caption": "THEY'RE SENDING A HEART. I BILLED THE SPONSORS." },
        { "text": "Heart drifting in. Try not to die on the way.", "caption": "HEART DRIFTING IN. DON'T DIE ON THE WAY." },
        { "text": "Pity heart, incoming. Don't waste it.", "caption": "PITY HEART INCOMING. DON'T WASTE IT." }
      ]
    },
    {
      "id": "idle",
      "priority": 1,
      "cooldown": 15,
      "variants": [
        { "text": "Are we waiting for something? Should I put on the elevator music?", "caption": "SHOULD I PUT ON THE ELEVATOR MUSIC?" },
        { "text": "Hello? Apprentice? Blink twice if the imps have already eaten your brain.", "caption": "BLINK TWICE IF THEY ATE YOUR BRAIN." },
        { "text": "Standing still is a strategy, I suppose. So is lying down. Both end the same way.", "caption": "STANDING STILL IS A STRATEGY. SO IS LYING DOWN." },
        { "text": "The audience paid for mayhem, not a statue. Move something. Anything. A finger.", "caption": "THEY PAID FOR MAYHEM, NOT A STATUE." },
        { "text": "I've seen faster reflexes from a cursed footstool. And it was a very lazy footstool.", "caption": "FASTER REFLEXES FROM A CURSED FOOTSTOOL." },
        { "text": "Take your time. It's not like there are things trying to chew your face. Oh wait.", "caption": "TAKE YOUR TIME. OH WAIT." },
        { "text": "Is the wizard buffering?", "caption": "IS THE WIZARD BUFFERING?" },
        { "text": "Asleep? The imps aren't.", "caption": "ASLEEP? THE IMPS AREN'T." }
      ]
    },
    {
      "id": "stall_warning",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Thirty seconds and the room is still full? Cinderwyrm is stretching her wings, and she does NOT do refunds.", "caption": "CINDERWYRM IS COMING. NO REFUNDS." },
        { "text": "Too slow, apprentice! I'm letting the dragon out. Don't worry, she's only had a light breakfast.", "caption": "TOO SLOW! I'M LETTING THE DRAGON OUT." },
        { "text": "Time's up! Cinderwyrm, darling, dinner is ready. It's the one in the robe.", "caption": "CINDERWYRM, DINNER IS READY. THE ONE IN THE ROBE." },
        { "text": "Clock's dead. So are you, shortly. Cinderwyrm!", "caption": "CLOCK'S DEAD. SO ARE YOU, SHORTLY. CINDERWYRM!" },
        { "text": "Taking your time? She takes limbs. Wyrm's out!", "caption": "SHE TAKES LIMBS. WYRM'S OUT!" },
        { "text": "Slow wizard, hot dragon. Here she comes.", "caption": "SLOW WIZARD, HOT DRAGON. HERE SHE COMES." }
      ]
    },
    {
      "id": "corner_camping",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Is that a corner? Are you HIDING in my arena? Cinderwyrm! Flush them out!", "caption": "HIDING IN MY ARENA? CINDERWYRM! FLUSH THEM OUT!" },
        { "text": "Cowering in the corner like a wet cat! Fine. Let's see how you like it toasted.", "caption": "WET CAT IN THE CORNER. LET'S TOAST IT." },
        { "text": "The corner won't save you. Nothing saves you. But mostly not the corner. Release the wyrm!", "caption": "THE CORNER WON'T SAVE YOU. RELEASE THE WYRM!" },
        { "text": "Corner camping? She loves a corner. Cinderwyrm!", "caption": "SHE LOVES A CORNER. CINDERWYRM!" },
        { "text": "Hiding? She roasts the shy ones first.", "caption": "HIDING? SHE ROASTS THE SHY ONES FIRST." },
        { "text": "That corner's a grave with a view. Wyrm!", "caption": "A GRAVE WITH A VIEW. WYRM!" }
      ]
    },
    {
      "id": "dragon_arrive",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "HERE COMES CINDERWYRM! Rent is due, and the currency is YOU!", "caption": "HERE COMES CINDERWYRM! RENT IS DUE!" },
        { "text": "Cinderwyrm has entered the arena! She can't be killed, she can't be bargained with, and she thinks you look delicious.", "caption": "CINDERWYRM HAS ENTERED. SHE THINKS YOU LOOK DELICIOUS." },
        { "text": "Oh dear. The dragon is out. Word of advice: fire is very bad for robes. Run!", "caption": "THE DRAGON IS OUT. FIRE IS BAD FOR ROBES. RUN!" },
        { "text": "CINDERWYRM! Fire safety was never our strong suit.", "caption": "CINDERWYRM! FIRE SAFETY WAS NEVER OUR STRONG SUIT." },
        { "text": "The wyrm is loose! Hope your robe's flame-retardant. It isn't.", "caption": "THE WYRM IS LOOSE! YOUR ROBE ISN'T FLAME-RETARDANT." },
        { "text": "Dragon in the house! Somebody hide the wizard.", "caption": "DRAGON IN THE HOUSE! HIDE THE WIZARD." },
        { "text": "Cinderwyrm's up! Run first, scream second.", "caption": "CINDERWYRM'S UP! RUN FIRST, SCREAM SECOND." }
      ]
    },
    {
      "id": "dragon_burn",
      "priority": 3,
      "cooldown": 6,
      "variants": [
        { "text": "TOASTED! Ha! Medium rare, just how she likes them!", "caption": "TOASTED! MEDIUM RARE!" },
        { "text": "Oh, that's a full-body sunburn. Should have cleared the room, apprentice!", "caption": "FULL-BODY SUNBURN. SHOULD HAVE CLEARED THE ROOM!" },
        { "text": "Crispy! She likes them well done!", "caption": "CRISPY! SHE LIKES THEM WELL DONE!" },
        { "text": "Flambe! The apprentice is served!", "caption": "FLAMBE! THE APPRENTICE IS SERVED!" },
        { "text": "Hot hot hot! There go the eyebrows!", "caption": "HOT HOT HOT! THERE GO THE EYEBROWS!" },
        { "text": "Roasted! Smells like a career ending.", "caption": "ROASTED! SMELLS LIKE A CAREER ENDING." },
        { "text": "Dragon fire! Robes were a bad choice.", "caption": "DRAGON FIRE! ROBES WERE A BAD CHOICE." }
      ]
    },
    {
      "id": "weapon_cleaver",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "SUN-CLEAVER! EXTRA CRISPY!", "caption": "SUN-CLEAVER! EXTRA CRISPY!" },
        { "text": "THE SUN-FORGED CLEAVER! Swing wide and apologize to no one!", "caption": "SUN-FORGED CLEAVER! APOLOGIZE TO NO ONE!" },
        { "text": "SUN-CLEAVER! Slice with sunshine!", "caption": "SUN-CLEAVER! SLICE WITH SUNSHINE!" },
        { "text": "CLEAVER! Broad, bright, and rude!", "caption": "CLEAVER! BROAD, BRIGHT, AND RUDE!" },
        { "text": "SUN-FORGED CLEAVER! Dawn cuts both ways!", "caption": "SUN-FORGED CLEAVER! DAWN CUTS BOTH WAYS!" },
        { "text": "CLEAVER UP! Swing like you mean it!", "caption": "CLEAVER UP! SWING LIKE YOU MEAN IT!" }
      ]
    },
    {
      "id": "weapon_lightning",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "UNLIMITED... POWER!", "caption": "UNLIMITED... POWER!" },
        { "text": "LIGHTNING STAFF! Hold the trigger and let the physics sort them out!", "caption": "LIGHTNING STAFF! LET PHYSICS SORT THEM OUT!" },
        { "text": "LIGHTNING STAFF! Hold and cook!", "caption": "LIGHTNING STAFF! HOLD AND COOK!" },
        { "text": "Thunder in your hands! Don't drop it!", "caption": "THUNDER IN YOUR HANDS! DON'T DROP IT!" },
        { "text": "STAFF OF STORMS! Feel the static!", "caption": "STAFF OF STORMS! FEEL THE STATIC!" },
        { "text": "Lightning! The imps hate this one!", "caption": "LIGHTNING! THE IMPS HATE THIS ONE!" }
      ]
    },
    {
      "id": "weapon_crossbow",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "PHASE SHOT! NO ESCAPE!", "caption": "PHASE SHOT! NO ESCAPE!" },
        { "text": "PHASE-ARROW CROSSBOW! It goes through everything. Everything. Aim responsibly. Or don't!", "caption": "PHASE-ARROW! IT GOES THROUGH EVERYTHING!" },
        { "text": "PHASE CROSSBOW! Walls are a rumor!", "caption": "PHASE CROSSBOW! WALLS ARE A RUMOR!" },
        { "text": "Phase-arrows! Nothing's thick enough to hide behind!", "caption": "NOTHING'S THICK ENOUGH TO HIDE BEHIND!" },
        { "text": "CROSSBOW! Threads through crowds like gossip!", "caption": "CROSSBOW! THREADS THROUGH CROWDS LIKE GOSSIP!" },
        { "text": "Phase shot armed! Aim through, not at!", "caption": "PHASE SHOT ARMED! AIM THROUGH, NOT AT!" }
      ]
    },
    {
      "id": "weapon_void",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "SINGULARITY! CLEAN UP AISLE THREE!", "caption": "SINGULARITY! CLEAN UP AISLE THREE!" },
        { "text": "VOID ORB! Gravity's new boss!", "caption": "VOID ORB! GRAVITY'S NEW BOSS!" },
        { "text": "SINGULARITY! Everything goes in. Nothing comes back.", "caption": "SINGULARITY! NOTHING COMES BACK." },
        { "text": "VOID! Pull them in, apprentice!", "caption": "VOID! PULL THEM IN!" },
        { "text": "The void hungers! Feed it imps!", "caption": "THE VOID HUNGERS! FEED IT IMPS!" },
        { "text": "Black hole in hand! Careful where you point!", "caption": "BLACK HOLE IN HAND! CAREFUL WHERE YOU POINT!" }
      ]
    },
    {
      "id": "weapon_scythe",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "SOUL HARVEST! SLURP IT UP!", "caption": "SOUL HARVEST! SLURP IT UP!" },
        { "text": "SOUL SCYTHE! Reap, then giggle!", "caption": "SOUL SCYTHE! REAP, THEN GIGGLE!" },
        { "text": "SCYTHE! Death's day off, your day on!", "caption": "SCYTHE! DEATH'S DAY OFF, YOUR DAY ON!" },
        { "text": "Soul harvest! Grim, and glorious!", "caption": "SOUL HARVEST! GRIM, AND GLORIOUS!" },
        { "text": "The scythe! Swing it, then explain it to a priest!", "caption": "THE SCYTHE! EXPLAIN IT TO A PRIEST LATER!" },
        { "text": "SCYTHE TIME! Souls go slurp!", "caption": "SCYTHE TIME! SOULS GO SLURP!" }
      ]
    },
    {
      "id": "weapon_hydra",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "HYDRA STORM! MORE EXPLOSIONS!", "caption": "HYDRA STORM! MORE EXPLOSIONS!" },
        { "text": "HYDRA STORM! Fire in every direction!", "caption": "HYDRA STORM! FIRE IN EVERY DIRECTION!" },
        { "text": "Hydra in hand! One shot, many regrets!", "caption": "HYDRA IN HAND! ONE SHOT, MANY REGRETS!" },
        { "text": "HYDRA! Because one explosion is boring!", "caption": "HYDRA! ONE EXPLOSION IS BORING!" },
        { "text": "Hydra storm! Cover your ears, or don't!", "caption": "HYDRA STORM! COVER YOUR EARS, OR DON'T!" },
        { "text": "HYDRA! More heads, more booms!", "caption": "HYDRA! MORE HEADS, MORE BOOMS!" }
      ]
    },
    {
      "id": "overcharge",
      "priority": 5,
      "cooldown": 10,
      "variants": [
        { "text": "OVERCHARGE! DOUBLE THE MAYHEM! Somebody call the fire department!", "caption": "OVERCHARGE! DOUBLE THE MAYHEM!" },
        { "text": "OVERCHARGE! Oh, that's too much power for one apprentice. I love it. Don't stop!", "caption": "OVERCHARGE! TOO MUCH POWER. DON'T STOP!" },
        { "text": "OVERCHARGE! The wand is screaming, the imps are screaming, I am screaming! Wonderful!", "caption": "OVERCHARGE! EVERYONE IS SCREAMING! WONDERFUL!" },
        { "text": "OVERCHARGE! Wand's gone feral!", "caption": "OVERCHARGE! WAND'S GONE FERAL!" },
        { "text": "OVERCHARGE! Too much juice! Perfect!", "caption": "OVERCHARGE! TOO MUCH JUICE! PERFECT!" },
        { "text": "MAXIMUM MAGIC! Try not to explode!", "caption": "MAXIMUM MAGIC! TRY NOT TO EXPLODE!" },
        { "text": "That's gotta hurt! For the room! OVERCHARGE!", "caption": "THAT'S GOTTA HURT! FOR THE ROOM! OVERCHARGE!" },
        { "text": "Overcharge! The sponsors just stood up!", "caption": "OVERCHARGE! THE SPONSORS JUST STOOD UP!" }
      ]
    },
    {
      "id": "weapon_expired",
      "priority": 1,
      "cooldown": 12,
      "variants": [
        { "text": "Aww. Back to the little stick.", "caption": "AWW. BACK TO THE LITTLE STICK." },
        { "text": "And the fun is over. Enjoy your twig, apprentice.", "caption": "FUN'S OVER. ENJOY YOUR TWIG." },
        { "text": "Weapon expired. Like your warranty. And, soon, you.", "caption": "EXPIRED. LIKE YOUR WARRANTY. AND SOON, YOU." },
        { "text": "Poof. Back to poking things.", "caption": "POOF. BACK TO POKING THINGS." },
        { "text": "Spent. Like your dignity.", "caption": "SPENT. LIKE YOUR DIGNITY." },
        { "text": "Toy's gone. Twig's back. Tragic.", "caption": "TOY'S GONE. TWIG'S BACK. TRAGIC." }
      ]
    },
    {
      "id": "prize_cabbage",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A GOLDEN CABBAGE! YOUR RETIREMENT IS SECURED!", "caption": "A GOLDEN CABBAGE! RETIREMENT SECURED!" },
        { "text": "SOLID GOLD CABBAGE! Delicious, nutritious, and worth more than your house!", "caption": "GOLD CABBAGE! WORTH MORE THAN YOUR HOUSE!" },
        { "text": "GOLDEN CABBAGE! Leafy riches!", "caption": "GOLDEN CABBAGE! LEAFY RICHES!" },
        { "text": "A GOLD CABBAGE! Coleslaw for kings!", "caption": "A GOLD CABBAGE! COLESLAW FOR KINGS!" },
        { "text": "Cabbage of gold! Eat it or retire on it!", "caption": "CABBAGE OF GOLD! EAT IT OR RETIRE ON IT!" },
        { "text": "GOLDEN CABBAGE! Heavier than your future!", "caption": "GOLDEN CABBAGE! HEAVIER THAN YOUR FUTURE!" }
      ]
    },
    {
      "id": "prize_hat",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A NEW HAT! NOW YOU'RE FASHIONABLE AND DYING!", "caption": "A NEW HAT! FASHIONABLE AND DYING!" },
        { "text": "A WIZARD HAT! Finally, you look like you know what you're doing. You don't, but you look it!", "caption": "A WIZARD HAT! YOU LOOK COMPETENT NOW!" },
        { "text": "A HAT! Pointy means powerful!", "caption": "A HAT! POINTY MEANS POWERFUL!" },
        { "text": "NEW HAT! Same head, sadly.", "caption": "NEW HAT! SAME HEAD, SADLY." },
        { "text": "Wizard hat! Now dress like you'll survive!", "caption": "WIZARD HAT! DRESS LIKE YOU'LL SURVIVE!" },
        { "text": "A HAT! Style won't stop imps, but nice!", "caption": "A HAT! STYLE WON'T STOP IMPS, BUT NICE!" }
      ]
    },
    {
      "id": "prize_chalice",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A GOLDEN CHALICE! DRINK LIKE AN ARCHMAGE!", "caption": "A GOLDEN CHALICE! DRINK LIKE AN ARCHMAGE!" },
        { "text": "SOLID GOLD GOBLET! Pour the victory potion!", "caption": "GOLD GOBLET! POUR THE VICTORY POTION!" },
        { "text": "A CHALICE! Guaranteed 100 percent pure wizard gold!", "caption": "A CHALICE! 100% WIZARD GOLD!" },
        { "text": "GOLDEN CHALICE! Don't spill the good stuff!", "caption": "GOLDEN CHALICE! DON'T SPILL!" },
        { "text": "A CHALICE! Finally, some class in this pit!", "caption": "A CHALICE! FINALLY, SOME CLASS!" }
      ]
    },
    {
      "id": "prize_gold_chest",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A CHEST OF WIZARD GOLD! DON'T SPEND IT ALL ON WANDS!", "caption": "CHEST OF GOLD! DON'T SPEND IT ALL ON WANDS!" },
        { "text": "CHEST OF GOLD! More coins than sense!", "caption": "CHEST OF GOLD! MORE COINS THAN SENSE!" },
        { "text": "HEAVY GOLD CHEST! Lift with your knees, apprentice!", "caption": "HEAVY GOLD! LIFT WITH YOUR KNEES!" },
        { "text": "A CHEST OF GOLD! Jackpot in the dungeon!", "caption": "CHEST OF GOLD! JACKPOT!" },
        { "text": "GOLD CHEST! Riches beyond your brief lifespan!", "caption": "GOLD CHEST! RICHES BEYOND YOUR LIFESPAN!" }
      ]
    },
    {
      "id": "prize_spellbook",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "AN ANCIENT GRIMOIRE! TOO BAD YOU CAN'T READ RUNES!", "caption": "ANCIENT GRIMOIRE! TOO BAD YOU CAN'T READ!" },
        { "text": "A FORBIDDEN SPELLBOOK! Don't open page forty-two!", "caption": "FORBIDDEN SPELLBOOK! DON'T OPEN PAGE 42!" },
        { "text": "A SPELLBOOK! Knowledge is power, but blasting is faster!", "caption": "SPELLBOOK! KNOWLEDGE IS POWER!" },
        { "text": "ANCIENT SPELLBOOK! Bound in leather and mystery!", "caption": "SPELLBOOK! BOUND IN MYSTERY!" },
        { "text": "A GRIMOIRE! Try not to summon another demon by accident!", "caption": "GRIMOIRE! DON'T SUMMON MORE DEMONS!" }
      ]
    },
    {
      "id": "prize_crystal_ball",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A MYSTIC CRYSTAL BALL! I FORESEE MORE BLASTING!", "caption": "CRYSTAL BALL! I FORESEE MORE BLASTING!" },
        { "text": "SCRYING ORB! It sees your future: highly questionable!", "caption": "SCRYING ORB! FUTURE: HIGHLY QUESTIONABLE!" },
        { "text": "A CRYSTAL BALL! Pure arcane clairvoyance in a glass sphere!", "caption": "CRYSTAL BALL! PURE CLAIRVOYANCE!" },
        { "text": "CRYSTAL BALL! Ask it if you're going to survive. Spoiler: nope!", "caption": "CRYSTAL BALL! WILL YOU SURVIVE? NOPE!" },
        { "text": "A SCRYING ORB! Gazing into eternity, or just admiring yourself!", "caption": "SCRYING ORB! GAZING INTO ETERNITY!" }
      ]
    },
    {
      "id": "prize_potion",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "AN UNKNOWN POTION! DRINK IT! WHAT'S THE WORST THAT HAPPENS?", "caption": "UNKNOWN POTION! DRINK IT!" },
        { "text": "BUBBLING ELIXIR! Smells like glowing berries and danger!", "caption": "BUBBLING ELIXIR! SMELLS LIKE DANGER!" },
        { "text": "A MAGIC FLASK! Tastes like grape and wild lightning!", "caption": "MAGIC FLASK! TASTES LIKE LIGHTNING!" },
        { "text": "WIZARD POTION! Instant rejuvenation in a corked flask!", "caption": "WIZARD POTION! INSTANT REJUVENATION!" },
        { "text": "A POTION! Bottoms up, you glowing reckless maniac!", "caption": "A POTION! BOTTOMS UP!" }
      ]
    },
    {
      "id": "prize_hourglass",
      "priority": 3,
      "cooldown": 0,
      "variants": [
        { "text": "A CHRONO-HOURGLASS! BORROWED TIME FOR A BORROWED WIZARD!", "caption": "CHRONO-HOURGLASS! BORROWED TIME!" },
        { "text": "AN HOURGLASS! Sands of infinity in a nice brass frame!", "caption": "AN HOURGLASS! SANDS OF INFINITY!" },
        { "text": "TIME SANDS! Tick tock, apprentice, the imps don't wait!", "caption": "TIME SANDS! TICK TOCK, APPRENTICE!" },
        { "text": "AN HOURGLASS! Turn back time, or just look mysterious holding it!", "caption": "AN HOURGLASS! LOOK MYSTERIOUS!" },
        { "text": "CHRONO-SAND! More seconds on the clock, more spells in the air!", "caption": "CHRONO-SAND! MORE SPELLS IN THE AIR!" }
      ]
    },
    {
      "id": "boss_arrive_lich",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down? Then kneel for the headliner! Vormund the Unburied, Lich Archon of the Obsidian Vault! He has been dead for four hundred years and he is STILL better rested than you.", "caption": "VORMUND THE UNBURIED! DEAD FOUR CENTURIES, STILL BETTER RESTED." },
        { "text": "Here he comes! Vormund the Unburied! Bone, crown, and a grudge older than the arena. Watch the runes, apprentice. He does not miss on purpose.", "caption": "VORMUND THE UNBURIED! WATCH THE RUNES." },
        { "text": "The floor is empty, and the Lich Archon does not like an empty floor. Vormund, darling, the stage is yours. Try not to break the wizard too quickly.", "caption": "THE LICH ARCHON TAKES THE STAGE." },
        { "text": "Vormund the Unburied! Four centuries of bad temper!", "caption": "VORMUND! FOUR CENTURIES OF BAD TEMPER!" },
        { "text": "The Lich walks! Bones, crown, and no mercy!", "caption": "THE LICH WALKS! BONES, CROWN, NO MERCY!" },
        { "text": "Vormund rises! Watch the runes, apprentice!", "caption": "VORMUND RISES! WATCH THE RUNES!" }
      ]
    },
    {
      "id": "boss_arrive_druid",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "The portals are ash, so the garden wakes! Sylvara, the Thornqueen, Hierophant of the Verdant Deep! She grows on you. Literally. Keep moving!", "caption": "SYLVARA THE THORNQUEEN! SHE GROWS ON YOU. LITERALLY." },
        { "text": "Sylvara the Thornqueen has arrived! Half tree, half priestess, all thorns. Every spell she casts leaves seeds. Do not stand in the seeds.", "caption": "THE THORNQUEEN HAS ARRIVED! DO NOT STAND IN THE SEEDS." },
        { "text": "Oh, she's awake. The Hierophant has not lost a duel since the forest was a puddle. Bow, then run. Mostly run.", "caption": "THE HIEROPHANT IS AWAKE. BOW, THEN RUN." },
        { "text": "Sylvara the Thornqueen! Don't stand in the seeds!", "caption": "SYLVARA! DON'T STAND IN THE SEEDS!" },
        { "text": "The Thornqueen blooms! Prune her before she prunes you!", "caption": "PRUNE HER BEFORE SHE PRUNES YOU!" },
        { "text": "Sylvara! Roots, thorns, and zero patience!", "caption": "SYLVARA! ROOTS, THORNS, ZERO PATIENCE!" }
      ]
    },
    {
      "id": "boss_arrive_magus",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals cleared! And now, the main event: Ignatius Embercrown, the Ember Magus! Everything he touches is on fire, including his opinions. Move!", "caption": "IGNATIUS EMBERCROWN! EVERYTHING HE TOUCHES IS ON FIRE." },
        { "text": "The Ember Magus enters the arena! He has no face, only fire, and he still looks more confident than you. Dodge the rings!", "caption": "THE EMBER MAGUS! DODGE THE RINGS!" },
        { "text": "Ignatius! Embercrown! The only contestant I have ever had to hose down between rounds. Wands up, apprentice, this one throws hot.", "caption": "IGNATIUS EMBERCROWN! THIS ONE THROWS HOT." },
        { "text": "Ignatius Embercrown! Fire with a title!", "caption": "IGNATIUS EMBERCROWN! FIRE WITH A TITLE!" },
        { "text": "The Ember Magus! Dodge the rings or become one!", "caption": "DODGE THE RINGS OR BECOME ONE!" },
        { "text": "Embercrown enters! Bring water. Bring lots.", "caption": "EMBERCROWN ENTERS! BRING WATER. LOTS." }
      ]
    },
    {
      "id": "boss_arrive_warlord",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down! Brace the floor! Khargoth the Unbroken, the Golem Warlord! Two tons of basalt and one very short temper. When he lifts the hammer, you are already too close.", "caption": "KHARGOTH THE UNBROKEN! WHEN HE LIFTS THE HAMMER, MOVE." },
        { "text": "Here comes the heavy! Khargoth! Golem Warlord! He has never lost a fight, mostly because nobody survived long enough to file a complaint.", "caption": "KHARGOTH! GOLEM WARLORD! NOBODY SURVIVED TO COMPLAIN." },
        { "text": "Incoming! Khargoth the Unbroken! Mind the stomp, apprentice. The floor is about to have opinions.", "caption": "KHARGOTH! MIND THE STOMP!" },
        { "text": "Khargoth the Unbroken! Duck the hammer!", "caption": "KHARGOTH THE UNBROKEN! DUCK THE HAMMER!" },
        { "text": "The Golem Warlord! Two tons of bad news!", "caption": "THE GOLEM WARLORD! TWO TONS OF BAD NEWS!" },
        { "text": "Khargoth drops in! Literally! Move!", "caption": "KHARGOTH DROPS IN! LITERALLY! MOVE!" }
      ]
    },
    {
      "id": "boss_arrive_skullking",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down! All hail Mordrake Hollowcrown, the Skull King! No body, no manners, and a crown of skulls that bite. Keep your eyes on the crown, apprentice. It moves.", "caption": "MORDRAKE HOLLOWCROWN! THE CROWN BITES." },
        { "text": "The Skull King floats in! Mordrake! He lost his body in a bet and has been insufferable ever since. Watch the skulls, they launch!", "caption": "THE SKULL KING! WATCH THE SKULLS, THEY LAUNCH!" },
        { "text": "Mordrake Hollowcrown! He blinks, he cackles, he raises the dead like it's a hobby. Do not let him finish a sentence.", "caption": "MORDRAKE HOLLOWCROWN! DO NOT LET HIM FINISH A SENTENCE." },
        { "text": "Mordrake Hollowcrown! Mind the crown!", "caption": "MORDRAKE HOLLOWCROWN! MIND THE CROWN!" },
        { "text": "The Skull King! All head, all grudge!", "caption": "THE SKULL KING! ALL HEAD, ALL GRUDGE!" },
        { "text": "Mordrake blinks in! Watch the skulls!", "caption": "MORDRAKE BLINKS IN! WATCH THE SKULLS!" }
      ]
    },
    {
      "id": "boss_arrive_colossus",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down, and something is bubbling up through the floor! Glorp the Undivided, the Slime Colossus! Do not stand in the green. Do not stand NEAR the green.", "caption": "GLORP THE UNDIVIDED! DO NOT STAND IN THE GREEN." },
        { "text": "Glorp! The Undivided! Ha! For now. Hit him hard enough and you will meet the whole family.", "caption": "GLORP THE UNDIVIDED! FOR NOW." },
        { "text": "The Slime Colossus rises! He has eaten three contestants and a chandelier, and he is still hungry. Watch the acid arcs!", "caption": "THE SLIME COLOSSUS! WATCH THE ACID!" },
        { "text": "Glorp the Undivided! Mind the acid!", "caption": "GLORP THE UNDIVIDED! MIND THE ACID!" },
        { "text": "The Slime Colossus! It only gets messier!", "caption": "THE SLIME COLOSSUS! IT ONLY GETS MESSIER!" },
        { "text": "Glorp rises! Bring a mop!", "caption": "GLORP RISES! BRING A MOP!" }
      ]
    },
    {
      "id": "boss_arrive_matriarch",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down! Cover your ears! Vespera Nightbrood, the Bat Matriarch! Mother of every bat in this building and she has been counting. When she screeches, you go where she says.", "caption": "VESPERA NIGHTBROOD! WHEN SHE SCREECHES, YOU MOVE." },
        { "text": "From the rafters! Vespera Nightbrood! Wings like sails and a voice like a cracked bell. Watch the dive, apprentice, she never dives just once.", "caption": "VESPERA NIGHTBROOD! SHE NEVER DIVES JUST ONCE." },
        { "text": "The Bat Matriarch sweeps in! Vespera! She is fast, she is loud, and she brought the children.", "caption": "THE BAT MATRIARCH! SHE BROUGHT THE CHILDREN." },
        { "text": "Vespera Nightbrood! Watch the dive!", "caption": "VESPERA NIGHTBROOD! WATCH THE DIVE!" },
        { "text": "The Bat Matriarch! Cover your ears!", "caption": "THE BAT MATRIARCH! COVER YOUR EARS!" },
        { "text": "Vespera swoops in! Loud one, this!", "caption": "VESPERA SWOOPS IN! LOUD ONE, THIS!" }
      ]
    },
    {
      "id": "boss_arrive_sentinel",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down, and the statue is moving. The Watcher of the Ninth Gate, the Gargoyle Sentinel! It has stood in that wall for nine hundred years waiting for someone worth waking up for. Congratulations.", "caption": "THE WATCHER OF THE NINTH GATE! IT WOKE UP FOR YOU." },
        { "text": "The Gargoyle Sentinel wakes! Stone eyes, stone wings, and a beam that does not care about your feelings. Cross the line when it sweeps, not before!", "caption": "THE GARGOYLE SENTINEL! CROSS THE BEAM WHEN IT SWEEPS." },
        { "text": "The Watcher stirs! Nine hundred years of standing still and it is ready to stretch. On you.", "caption": "THE WATCHER STIRS! IT IS READY TO STRETCH." },
        { "text": "The Watcher of the Ninth Gate! Mind the beam!", "caption": "THE WATCHER! MIND THE BEAM!" },
        { "text": "The Gargoyle Sentinel! Stone that shoots back!", "caption": "THE GARGOYLE SENTINEL! STONE THAT SHOOTS BACK!" },
        { "text": "The statue wakes! Run when it aims!", "caption": "THE STATUE WAKES! RUN WHEN IT AIMS!" }
      ]
    },
    {
      "id": "boss_arrive_hexweaver",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down, and something is knitting the air. Quillix the Hexweaver, the Imp Hexweaver! An imp that read one book and never shut up about it. It hangs back, it throws curses, and it calls its little cousins to do the bleeding.", "caption": "QUILLIX THE HEXWEAVER! AN IMP THAT READ ONE BOOK." },
        { "text": "The Hexweaver arrives! Orbs, bolts, and a beam it is very proud of. Get close. It hates that.", "caption": "THE HEXWEAVER! GET CLOSE. IT HATES THAT." },
        { "text": "Quillix! The only imp in the arena with a library card and a grudge.", "caption": "QUILLIX! A LIBRARY CARD AND A GRUDGE." },
        { "text": "The Imp Hexweaver! Shoot the caster, not the cousins!", "caption": "THE HEXWEAVER! SHOOT THE CASTER!" },
        { "text": "Quillix the Hexweaver! Mind the orbs!", "caption": "QUILLIX! MIND THE ORBS!" },
        { "text": "A hexweaver lands! Small imp, big mouth, bigger spells!", "caption": "THE HEXWEAVER! SMALL IMP, BIGGER SPELLS!" }
      ]
    },
    {
      "id": "boss_arrive_ashmaw",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "The portals are down and the air is cooking. Ashmaw the Unquenched, the Cinder Titan! A skull the size of a cart, on fire, and it dives. It also brings smaller skulls, also on fire, also diving. Theme night.", "caption": "ASHMAW THE UNQUENCHED! THE CINDER TITAN!" },
        { "text": "Ashmaw comes! It swoops, it scatters fire, it spits cinders that chase you home. Do not stand where it looked.", "caption": "ASHMAW! DO NOT STAND WHERE IT LOOKED." },
        { "text": "The Cinder Titan! Nine hundred degrees of bad attitude, and it has picked a lane. Leave the lane.", "caption": "THE CINDER TITAN HAS PICKED A LANE. LEAVE IT." },
        { "text": "Ashmaw the Unquenched! Watch the dive!", "caption": "ASHMAW! WATCH THE DIVE!" },
        { "text": "The Cinder Titan lands! Everything it touches burns!", "caption": "THE CINDER TITAN! EVERYTHING IT TOUCHES BURNS!" },
        { "text": "Ashmaw! Big skull, bigger fire, no patience!", "caption": "ASHMAW! BIG SKULL, BIGGER FIRE!" }
      ]
    },
    {
      "id": "boss_arrive_bride",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "Portals down, and the torches just went cold. The Hollow Bride, the Wraith Matron! She was promised a wedding. She got a tower. Now everyone who visits is a guest, and the guests do not leave.", "caption": "THE HOLLOW BRIDE! THE GUESTS DO NOT LEAVE." },
        { "text": "The Bride arrives! Wisps that follow, bolts that don't miss, and a bridal party of wraiths. Keep moving or join the procession.", "caption": "THE BRIDE! KEEP MOVING OR JOIN THE PROCESSION." },
        { "text": "The Wraith Matron! Her veil is made of the last hundred contestants. Try not to add to the hem.", "caption": "THE WRAITH MATRON! DON'T ADD TO THE HEM." },
        { "text": "The Hollow Bride! Mind the wisps!", "caption": "THE HOLLOW BRIDE! MIND THE WISPS!" },
        { "text": "The Wraith Matron descends! Her bridesmaids bite!", "caption": "THE WRAITH MATRON! HER BRIDESMAIDS BITE!" },
        { "text": "The Bride! Cold hands, colder spells!", "caption": "THE BRIDE! COLD HANDS, COLDER SPELLS!" }
      ]
    },
    {
      "id": "boss_half",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "Half health on the headliner! Oh, now they're angry. Good! Angry means sloppy. Also faster. Mostly faster.", "caption": "HALF HEALTH! ANGRY MEANS SLOPPY. ALSO FASTER." },
        { "text": "You've cracked the boss in half! Not literally. Yet. Keep swinging, the crowd smells a finish!", "caption": "CRACKED IN HALF! THE CROWD SMELLS A FINISH!" },
        { "text": "Halfway there, apprentice! The boss is bleeding, or leaking, or whatever bosses do. Don't stop now!", "caption": "HALFWAY! THE BOSS IS LEAKING. DON'T STOP!" },
        { "text": "Half down! Now the boss is paying attention!", "caption": "HALF DOWN! NOW THEY'RE PAYING ATTENTION!" },
        { "text": "Boss is bleeding! Or leaking. Keep at it!", "caption": "BOSS IS BLEEDING! KEEP AT IT!" },
        { "text": "Halfway! The headliner looks nervous!", "caption": "HALFWAY! THE HEADLINER LOOKS NERVOUS!" }
      ]
    },
    {
      "id": "boss_down",
      "priority": 6,
      "cooldown": 0,
      "variants": [
        { "text": "BOSS DOWN! The headliner is a puddle! Ha! Somebody frame that wizard, they just made my ratings!", "caption": "BOSS DOWN! THEY JUST MADE MY RATINGS!" },
        { "text": "AND THE BOSS FALLS! Magnificent! Absolutely magnificent! I take full credit for booking you.", "caption": "THE BOSS FALLS! I TAKE FULL CREDIT." },
        { "text": "Down goes the boss! Down goes the boss! The gates are opening, the floor is yours, and the next one has already heard about you.", "caption": "DOWN GOES THE BOSS! THE FLOOR IS YOURS." },
        { "text": "BOSS DOWN! Frame that wizard!", "caption": "BOSS DOWN! FRAME THAT WIZARD!" },
        { "text": "The headliner falls! Encore denied!", "caption": "THE HEADLINER FALLS! ENCORE DENIED!" },
        { "text": "BOSS DOWN! Even I'm impressed. Briefly.", "caption": "BOSS DOWN! EVEN I'M IMPRESSED. BRIEFLY." },
        { "text": "That's gotta hurt! The headliner just learned gravity!", "caption": "THAT'S GOTTA HURT! THE HEADLINER LEARNED GRAVITY!" },
        { "text": "Champion down! Somebody write this one down!", "caption": "CHAMPION DOWN! WRITE THIS ONE DOWN!" }
      ]
    },
    {
      "id": "floor_cleared",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "FLOOR CLEARED! Every room, every portal, every imp! Take the stairs, the next floor has been warned about you.", "caption": "FLOOR CLEARED! THE NEXT FLOOR HAS BEEN WARNED." },
        { "text": "The whole floor, scrubbed clean! I'm almost impressed. Almost. Down you go!", "caption": "WHOLE FLOOR SCRUBBED! ALMOST IMPRESSED. DOWN YOU GO!" },
        { "text": "Floor complete! Big mana! Big prizes! And a bigger, meaner floor waiting below. Enjoy!", "caption": "FLOOR COMPLETE! BIG MANA! BIG PRIZES!" },
        { "text": "Floor cleared! Down you go, deeper and dumber!", "caption": "FLOOR CLEARED! DEEPER AND DUMBER!" },
        { "text": "Whole floor, scrubbed! The next one bites back.", "caption": "WHOLE FLOOR SCRUBBED! THE NEXT ONE BITES BACK." },
        { "text": "FLOOR DONE! The stairs are waiting. So is worse.", "caption": "FLOOR DONE! THE STAIRS ARE WAITING. SO IS WORSE." },
        { "text": "Floor clear! Big mana, bigger problems below!", "caption": "BIG MANA, BIGGER PROBLEMS BELOW!" }
      ]
    },
    {
      "id": "player_death",
      "priority": 6,
      "cooldown": 0,
      "variants": [
        { "text": "Ooooh, and that's a wrap! Somebody get a mop. Thank you for playing, we have lovely parting gifts, none of which you can use, because you're dead.", "caption": "AND THAT'S A WRAP! SOMEBODY GET A MOP." },
        { "text": "Aaand they're dead! Let's have a moment of silence. That's enough. Next contestant!", "caption": "DEAD! MOMENT OF SILENCE. THAT'S ENOUGH. NEXT!" },
        { "text": "Apprentice down! Cause of death: everything. Truly a team effort by the imps.", "caption": "CAUSE OF DEATH: EVERYTHING." },
        { "text": "Oh no. Oh dear. Oh well! The robe's still good, we'll wash it and hand it to the next one.", "caption": "OH WELL! WE'LL WASH THE ROBE FOR THE NEXT ONE." },
        { "text": "And the crowd goes... mildly disappointed! Better luck in your next incarnation. I hear slugs are peaceful.", "caption": "BETTER LUCK NEXT INCARNATION. SLUGS ARE PEACEFUL." },
        { "text": "Dead! Beautifully, stupidly dead.", "caption": "DEAD! BEAUTIFULLY, STUPIDLY DEAD." },
        { "text": "Wizard down! Cause of death: confidence.", "caption": "WIZARD DOWN! CAUSE OF DEATH: CONFIDENCE." },
        { "text": "That's gotta hurt. Permanently. Next!", "caption": "THAT'S GOTTA HURT. PERMANENTLY. NEXT!" },
        { "text": "And the lights go out! Thank you for dying on camera!", "caption": "THANK YOU FOR DYING ON CAMERA!" },
        { "text": "Dead wizard, live ratings! Everybody wins except you.", "caption": "DEAD WIZARD, LIVE RATINGS!" }
      ]
    },
    {
      "id": "kill_taunt",
      "priority": 1,
      "cooldown": 14,
      "variants": [
        { "text": "Splat! Lovely.", "caption": "SPLAT! LOVELY." },
        { "text": "Another one for the mop.", "caption": "ANOTHER ONE FOR THE MOP." },
        { "text": "Imp jam! Spread it thin.", "caption": "IMP JAM! SPREAD IT THIN." },
        { "text": "Squish! My favorite sound.", "caption": "SQUISH! MY FAVORITE SOUND." },
        { "text": "Dead thing! Next!", "caption": "DEAD THING! NEXT!" },
        { "text": "Popped like a grape!", "caption": "POPPED LIKE A GRAPE!" },
        { "text": "Down goes the fiend!", "caption": "DOWN GOES THE FIEND!" },
        { "text": "Tidy kill. Untidy corpse.", "caption": "TIDY KILL. UNTIDY CORPSE." },
        { "text": "That's gotta hurt! In several directions!", "caption": "THAT'S GOTTA HURT! IN SEVERAL DIRECTIONS!" },
        { "text": "Splat two! The mop is applying for hazard pay.", "caption": "THE MOP IS APPLYING FOR HAZARD PAY." },
        { "text": "Fiend down! Somebody count the pieces.", "caption": "FIEND DOWN! COUNT THE PIECES." },
        { "text": "Oh, they felt that. Briefly.", "caption": "THEY FELT THAT. BRIEFLY." }
      ]
    },
    {
      "id": "golem_down",
      "priority": 2,
      "cooldown": 20,
      "variants": [
        { "text": "Golem down! Rubble everywhere!", "caption": "GOLEM DOWN! RUBBLE EVERYWHERE!" },
        { "text": "The big one's gravel! Nice!", "caption": "THE BIG ONE'S GRAVEL! NICE!" },
        { "text": "Golem cracked! Timber!", "caption": "GOLEM CRACKED! TIMBER!" },
        { "text": "Stone giant, stone dead!", "caption": "STONE GIANT, STONE DEAD!" },
        { "text": "Rock, meet wand! Wand wins!", "caption": "ROCK, MEET WAND! WAND WINS!" },
        { "text": "Golem's a pile! Somebody sweep!", "caption": "GOLEM'S A PILE! SOMEBODY SWEEP!" }
      ]
    },
    {
      "id": "dragon_roar",
      "priority": 3,
      "cooldown": 9,
      "variants": [
        { "text": "Deep breath! Hers, not yours! Move!", "caption": "DEEP BREATH! HERS, NOT YOURS! MOVE!" },
        { "text": "Incoming fire! Scatter!", "caption": "INCOMING FIRE! SCATTER!" },
        { "text": "She's inhaling! Run!", "caption": "SHE'S INHALING! RUN!" },
        { "text": "Wyrm's winding up! Don't stand there!", "caption": "WYRM'S WINDING UP! DON'T STAND THERE!" },
        { "text": "Fire's coming! Legs, apprentice, legs!", "caption": "FIRE'S COMING! LEGS, APPRENTICE, LEGS!" },
        { "text": "Breath attack! Duck, dodge, pray!", "caption": "BREATH ATTACK! DUCK, DODGE, PRAY!" }
      ]
    },
    {
      "id": "prize_wave",
      "priority": 3,
      "cooldown": 10,
      "variants": [
        { "text": "BIG MANA! BIG PRIZES!", "caption": "BIG MANA! BIG PRIZES!" },
        { "text": "Prizes on the floor! Grab greedily!", "caption": "PRIZES ON THE FLOOR! GRAB GREEDILY!" },
        { "text": "Loot wave! The sponsors are feeling generous!", "caption": "LOOT WAVE! THE SPONSORS ARE GENEROUS!" },
        { "text": "BIG PRIZES! Small dignity!", "caption": "BIG PRIZES! SMALL DIGNITY!" },
        { "text": "Prize time! Hoard it all!", "caption": "PRIZE TIME! HOARD IT ALL!" },
        { "text": "Gems and gifts! Shop fast!", "caption": "GEMS AND GIFTS! SHOP FAST!" }
      ]
    },
    {
      "id": "intro_lore_1",
      "priority": 3,
      "cooldown": 0,
      "speed": 0.94,
      "prompt": "dark prestige cold open, carved consonants, linger on Arena and roars",
      "direction": "You are Archmage Vaelen, host of the Arcane Broadcast. Do not read these notes aloud.\nTone: dark prestige cold open, velvet and iron, not jokey yet.\nVibe: live from the tower at night, cinematic, slightly ominous, a sold-out arena just off-mic.\nEnunciation: carve every consonant. Linger on Arena and roars. Full stops are real pauses. Do not swallow the ends of words. Speak as if the seven realms are listening.",
      "variants": [
        { "text": "[solemn] Every night, the seven realms tune in to the Arcane Broadcast. [dramatic] Beneath the Tower lies the Grand Arena. [low] Portals open. Fiends pour out. [pause] [intense] The crowd... [excited] roars.", "caption": "EVERY NIGHT. THE ARCANE BROADCAST. THE CROWD ROARS." },
        { "text": "[hushed] Each night, across the seven realms, the Arcane Broadcast begins. [dramatic] Beneath the Tower: the Grand Arena. [intense] Portals tear open. Fiends pour forth. [pause] And the crowd... [excited] roars.", "caption": "SEVEN REALMS. PORTALS TEAR OPEN. THE CROWD ROARS." },
        { "text": "[solemn] Night falls. The seven realms gather for the Arcane Broadcast. [low] Deep beneath the Tower waits the Grand Arena. [dramatic] Portals open. Fiends flood in. [intense] The crowd demands blood.", "caption": "NIGHT FALLS. THE GRAND ARENA AWAITS. THE CROWD DEMANDS BLOOD." },
        { "text": "[dramatic] From every corner of the seven realms, they tune in to the Arcane Broadcast. [solemn] Beneath the Tower, the Grand Arena awakens. [low] Portals open. Fiends pour out. [excited] The crowd roars.", "caption": "THE ARCANE BROADCAST. THE GRAND ARENA AWAKENS." }
      ]
    },
    {
      "id": "intro_lore_2",
      "priority": 3,
      "cooldown": 0,
      "speed": 0.96,
      "prompt": "velvet showman, dry punchline, carved consonants",
      "direction": "You are Archmage Vaelen, host of the Arcane Broadcast. Do not read these notes aloud.\nTone: the smile after the knife. Bright on the prizes, dry on the catch.\nVibe: late-night prestige game show, gold on the table, a coffin in the small print.\nEnunciation: Gold, Relics, Mana are three separate beads. Hit the T in contestants. Do not whisper the last sentence. Do not read tags or these notes.",
      "variants": [
        { "text": "[dramatic] The prizes are real. [excited] Gold. Relics. A lifetime supply of mana. [pause] [solemn] The small print is also real. Contestants rarely leave.", "caption": "THE PRIZES ARE REAL. CONTESTANTS RARELY LEAVE." },
        { "text": "[excited] Gold. Relics. Mana enough for a lifetime. [dramatic] The prizes are real. [pause] [solemn] So is the fine print. Almost no one walks out.", "caption": "GOLD. RELICS. MANA. ALMOST NO ONE WALKS OUT." },
        { "text": "[dramatic] The prizes? [excited] Real. Gold. Relics. A lifetime of mana. [pause] [solemn] The catch? Also real. Contestants rarely leave.", "caption": "THE PRIZES ARE REAL. THE CATCH IS TOO." },
        { "text": "[solemn] They come for gold, for relics, for a lifetime supply of mana. [dramatic] The prizes are real. [pause] [low] The small print is also real. Contestants rarely leave.", "caption": "THEY COME FOR GOLD. CONTESTANTS RARELY LEAVE." }
      ]
    },
    {
      "id": "intro_welcome",
      "priority": 3,
      "cooldown": 0,
      "prompt": "big room showman, proud, a little cruel, say Vaelen as VAY-len",
      "direction": "You are Archmage Vaelen, host of the Arcane Broadcast. Do not read these notes aloud.\nTone: showman who owns the room. Big, warm, a little cruel.\nVibe: Saturday-night arena broadcast, velvet jacket, blood on the sand, cameras in the rafters.\nEnunciation: open vowels on Seven realms and Grand Arena. Say Vaelen as VAY-len, never VAY-lin or vah-LEN. Hit the D in doomed. Do not swallow good evening.",
      "variants": [
        { "text": "[excited] Seven realms, good evening! [proud] \"/ˈveɪ.lən/\" here, live from the Grand Arena, [mischievously] with one very doomed contestant.", "caption": "LIVE FROM THE GRAND ARENA. ONE VERY DOOMED CONTESTANT." },
        { "text": "[excited] Welcome back to the Arcane Broadcast! [slick] One arena, zero refunds. [proud] Your host, Archmage \"/ˈveɪ.lən/\".", "caption": "ONE ARENA. ZERO REFUNDS. YOUR HOST, ARCHMAGE VAELEN." },
        { "text": "[shouting] Seven realms, you are LIVE from the Grand Arena! [proud] \"/ˈveɪ.lən/\" here, [amused] and the mop is already on standby.", "caption": "LIVE FROM THE GRAND ARENA. THE MOP IS ON STANDBY." },
        { "text": "[excited] \"/ˈveɪ.lən/\" here, seven realms! [gleeful] Big mana! Big prizes! [sarcastic] And a contestant who thinks this is a talent show.", "caption": "BIG MANA! BIG PRIZES! AND A CONTESTANT WHO THINKS THIS IS A TALENT SHOW." }
      ]
    },
    {
      "id": "intro_contestant",
      "priority": 3,
      "cooldown": 0,
      "prompt": "affectionate roast, crisp consonants, throwaway laugh on the sting",
      "direction": "You are Archmage Vaelen, host of the Arcane Broadcast. Do not read these notes aloud.\nTone: affectionate roast. You like this lamb. The cameras will not.\nVibe: introducing a contestant to a hungry crowd, smile wide, knife behind it.\nEnunciation: crisp on robe, wand, scar. Bite the T in contestant. The last beat is a throwaway laugh, not a mutter. Leave space after the setup.",
      "variants": [
        { "text": "[excited] Tonight's contestant! [slick] Fresh robe, clean wand, not a single scar. [pause] [amused] Give it a minute.", "caption": "FRESH ROBE. CLEAN WAND. NOT A SINGLE SCAR. GIVE IT A MINUTE." },
        { "text": "[proud] Please welcome tonight's contestant! [warm] Graduated the academy. [sarcastic] Bottom of the class, [amused] but graduated.", "caption": "BOTTOM OF THE CLASS, BUT GRADUATED." },
        { "text": "[slick] Tonight's contestant, a real up-and-comer. [pause] [mischievously] Mostly comer. [dry] The crowd's betting on which portal gets them.", "caption": "THE CROWD'S BETTING ON WHICH PORTAL GETS THEM." },
        { "text": "[excited] And here comes tonight's contestant! [warm] Brave, punctual, [amused] and about to be famous for roughly four minutes.", "caption": "ABOUT TO BE FAMOUS FOR ROUGHLY FOUR MINUTES." }
      ]
    },
    {
      "id": "intro_stakes",
      "priority": 3,
      "cooldown": 0,
      "speed": 0.97,
      "prompt": "staccato rules slam, each verb a hit, WIN BIG is bigger",
      "direction": "You are Archmage Vaelen, host of the Arcane Broadcast. Do not read these notes aloud.\nTone: rules slam. No wink until the last clause.\nVibe: drumroll under the lights, the contract read aloud to the cheap seats.\nEnunciation: staccato. Each verb is its own hit. Kill. Smash. Survive. WIN BIG is bigger and longer. Highlight reel is crisp, not mumbled.",
      "variants": [
        { "text": "[intense] Kill the fiends. Smash the portals. Survive the boss. [excited] WIN BIG, [slick] or make the highlight reel.", "caption": "WIN BIG, OR MAKE THE HIGHLIGHT REEL." },
        { "text": "[intense] Fiends die. Portals break. [dry] The boss hates you personally. [excited] Survive all three. WIN BIG.", "caption": "THE BOSS HATES YOU PERSONALLY. SURVIVE ALL THREE, WIN BIG." },
        { "text": "[intense] Kill the fiends. Smash the portals. Survive the boss. [slick] Walk out rich, [mischievously] or leave in a bucket.", "caption": "WALK OUT RICH, OR LEAVE IN A BUCKET." }
      ]
    },
    {
      "id": "intro_sendoff",
      "priority": 3,
      "cooldown": 0,
      "prompt": "warm blessing then cruel sting, land the last word",
      "direction": "You are Archmage Vaelen, host of the Arcane Broadcast. Do not read these notes aloud.\nTone: warm and cruel. The blessing is real. The sting is the point.\nVibe: wink to the cheap seats as the gates start to close.\nEnunciation: Good luck is sincere and rounded. You will need it is the snap: hit need, smile on it. Do not trail off. Land the last word.",
      "variants": [
        { "text": "[warm] Good luck, contestant. [pause] [mischievously] You'll NEED it.", "caption": "GOOD LUCK. YOU'LL NEED IT!" },
        { "text": "[slick] Wands up, chin up, expectations down. [warm] Good luck. [amused] You'll NEED it.", "caption": "WANDS UP, CHIN UP, EXPECTATIONS DOWN." },
        { "text": "[excited] Smile for the scrying orbs. [warm] Good luck! [mischievously] You'll NEED it.", "caption": "SMILE FOR THE SCRYING ORBS. GOOD LUCK!" },
        { "text": "[slick] The crowd wants a show. I want ratings. [warm] Good luck. [amused] You'll NEED it.", "caption": "I WANT RATINGS. GOOD LUCK, YOU'LL NEED IT!" }
      ]
    },
    {
      "id": "menu_idle",
      "priority": 1,
      "cooldown": 10,
      "variants": [
        { "text": "Pick a difficulty, apprentice. The imps are getting bored, and bored imps get creative.", "caption": "PICK A DIFFICULTY. BORED IMPS GET CREATIVE." },
        { "text": "Three doors, one wizard, no refunds. Choose. The crowd has other plans tonight.", "caption": "THREE DOORS, ONE WIZARD, NO REFUNDS. CHOOSE." },
        { "text": "Take your time. The sponsors are billing me by the minute, so take slightly less time.", "caption": "THE SPONSORS BILL BY THE MINUTE. HURRY." },
        { "text": "Apprentice, Adept, Archmage. It's not a personality quiz. Well. It is a little.", "caption": "IT'S NOT A PERSONALITY QUIZ. WELL. A LITTLE." },
        { "text": "Still choosing? The dragon picked you ages ago.", "caption": "STILL CHOOSING? THE DRAGON PICKED YOU AGES AGO." },
        { "text": "Hello? The arena is warm, the mop is ready, and you're staring at a menu.", "caption": "THE MOP IS READY AND YOU'RE STARING AT A MENU." }
      ]
    },
    {
      "id": "menu_pick_apprentice",
      "priority": 2,
      "cooldown": 4,
      "variants": [
        { "text": "Apprentice! Soft imps, extra hearts, and I promise not to tell anyone. Much.", "caption": "APPRENTICE! I PROMISE NOT TO TELL ANYONE. MUCH." },
        { "text": "Apprentice tier. Training wheels on the broomstick. Adorable. Practical. Adorable.", "caption": "TRAINING WHEELS ON THE BROOMSTICK. ADORABLE." },
        { "text": "Apprentice! The kind option. The imps have been asked to bite gently. They said maybe.", "caption": "THE IMPS WERE ASKED TO BITE GENTLY. THEY SAID MAYBE." }
      ]
    },
    {
      "id": "menu_pick_adept",
      "priority": 2,
      "cooldown": 4,
      "variants": [
        { "text": "Adept. The show as it airs. Fair fights, real stakes, one mop.", "caption": "ADEPT. THE SHOW AS IT AIRS." },
        { "text": "Adept tier! Exactly as the sponsors intended. Everything hurts the normal amount.", "caption": "EVERYTHING HURTS THE NORMAL AMOUNT." },
        { "text": "Adept. A respectable choice. Respectable rarely survives, but it looks lovely on the poster.", "caption": "RESPECTABLE RARELY SURVIVES, BUT IT LOOKS LOVELY ON THE POSTER." }
      ]
    },
    {
      "id": "menu_pick_archmage",
      "priority": 2,
      "cooldown": 4,
      "variants": [
        { "text": "ARCHMAGE! Oh, the sponsors are going to love this. Somebody warm up the mop.", "caption": "ARCHMAGE! SOMEBODY WARM UP THE MOP." },
        { "text": "Archmage tier. Everything hits harder, spawns faster, and pays double. So does the funeral.", "caption": "PAYS DOUBLE. SO DOES THE FUNERAL." },
        { "text": "Archmage! Bold. Deranged. Excellent television. Wands up!", "caption": "BOLD. DERANGED. EXCELLENT TELEVISION." }
      ]
    },
    {
      "id": "commercial_out",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "A quick word from our sponsors!", "caption": "A QUICK WORD FROM OUR SPONSORS!" },
        { "text": "Don't touch that orb!", "caption": "DON'T TOUCH THAT ORB!" },
        { "text": "We'll be right back!", "caption": "WE'LL BE RIGHT BACK!" },
        { "text": "Sponsor break — hang tight!", "caption": "SPONSOR BREAK — HANG TIGHT!" },
        { "text": "And now, a word from the gold!", "caption": "AND NOW, A WORD FROM THE GOLD!" },
        { "text": "Hold that scream — commercial!", "caption": "HOLD THAT SCREAM — COMMERCIAL!" }
      ]
    },
    {
      "id": "gotta_hurt",
      "priority": 1,
      "cooldown": 16,
      "variants": [
        { "text": "That's gotta hurt!", "caption": "THAT'S GOTTA HURT!" },
        { "text": "That's gotta hurt! Walk it off, apprentice!", "caption": "THAT'S GOTTA HURT! WALK IT OFF!" },
        { "text": "Oof! That's gotta hurt. I heard the rib from here.", "caption": "THAT'S GOTTA HURT. I HEARD THE RIB." },
        { "text": "That's gotta hurt! Smile for the replay!", "caption": "THAT'S GOTTA HURT! SMILE FOR THE REPLAY!" },
        { "text": "Ow! That's the sound of a lesson!", "caption": "OW! THAT'S THE SOUND OF A LESSON!" },
        { "text": "Hit! That's gonna bruise in places you don't have names for.", "caption": "THAT'S GONNA BRUISE IN UNNAMED PLACES." },
        { "text": "That's gotta hurt! The crowd loved it. You, less so.", "caption": "THE CROWD LOVED IT. YOU, LESS SO." },
        { "text": "Yowch! That's gotta hurt. Ice is extra.", "caption": "YOWCH! ICE IS EXTRA." }
      ]
    },
    {
      "id": "mine_blast",
      "priority": 2,
      "cooldown": 16,
      "variants": [
        { "text": "That's gotta hurt! Floor mine! I did say mind the sparkle.", "caption": "THAT'S GOTTA HURT! FLOOR MINE!" },
        { "text": "BOOM! Somebody stepped on the furniture!", "caption": "BOOM! SOMEBODY STEPPED ON THE FURNITURE!" },
        { "text": "Mine! The floor just filed a complaint!", "caption": "MINE! THE FLOOR JUST FILED A COMPLAINT!" },
        { "text": "Crater! That's gotta hurt, and the tiles agree.", "caption": "CRATER! THE TILES AGREE." },
        { "text": "Floor mine! Surprise crater, compliments of the house.", "caption": "SURPRISE CRATER, COMPLIMENTS OF THE HOUSE." },
        { "text": "Ka-boom! The mine wins. The mop loses.", "caption": "KA-BOOM! THE MINE WINS. THE MOP LOSES." },
        { "text": "That's gotta hurt! Don't stand on the shiny disks!", "caption": "DON'T STAND ON THE SHINY DISKS!" },
        { "text": "Mine's away! Well. Was away. Now it's everywhere.", "caption": "MINE'S AWAY! NOW IT'S EVERYWHERE." }
      ]
    },
    {
      "id": "pickup_shield",
      "priority": 3,
      "cooldown": 12,
      "variants": [
        { "text": "Rune Ward! Spinning blades, complimentary attitude!", "caption": "RUNE WARD! SPINNING BLADES, COMPLIMENTARY ATTITUDE!" },
        { "text": "A ward! Something to hide behind that isn't a corner. Novel!", "caption": "A WARD! NOT A CORNER. NOVEL!" },
        { "text": "Shield up! The orbiters bite. So should you.", "caption": "SHIELD UP! THE ORBITERS BITE." },
        { "text": "Rune Ward! Three little knives on a leash. Don't trip on them.", "caption": "THREE LITTLE KNIVES ON A LEASH." },
        { "text": "Ward acquired! Now you have friends. Sharp ones.", "caption": "NOW YOU HAVE FRIENDS. SHARP ONES." },
        { "text": "The ward is live! Try not to waste it on the first sneeze.", "caption": "WARD LIVE! DON'T WASTE IT ON THE FIRST SNEEZE." }
      ]
    },
    {
      "id": "pickup_swift",
      "priority": 3,
      "cooldown": 12,
      "variants": [
        { "text": "Gale Step! Legs, apprentice! Use the expensive ones!", "caption": "GALE STEP! USE THE EXPENSIVE LEGS!" },
        { "text": "Speed! The floor just got longer and you just got rude.", "caption": "THE FLOOR GOT LONGER. YOU GOT RUDE." },
        { "text": "Gale Step! Run like the wyrm is already here. She likes that.", "caption": "RUN LIKE THE WYRM IS ALREADY HERE." },
        { "text": "Faster! The imps hate a moving target. So do I. Do it anyway.", "caption": "THE IMPS HATE A MOVING TARGET. DO IT ANYWAY." },
        { "text": "Swift feet! Don't spend it standing still. That's just rude.", "caption": "SWIFT FEET! DON'T STAND STILL." },
        { "text": "Gale Step! Now you're late for everything, but fashionably.", "caption": "LATE FOR EVERYTHING, BUT FASHIONABLY." }
      ]
    },
    {
      "id": "buff_expired",
      "priority": 1,
      "cooldown": 14,
      "variants": [
        { "text": "And the perk is gone! Back to walking like a person. Tragic.", "caption": "THE PERK IS GONE. BACK TO WALKING. TRAGIC." },
        { "text": "Ward's out! The orbiters clocked off. You're alone again.", "caption": "WARD'S OUT. YOU'RE ALONE AGAIN." },
        { "text": "Speed's done! Those legs just remembered they're mortal.", "caption": "SPEED'S DONE. THE LEGS REMEMBERED THEY'RE MORTAL." },
        { "text": "Buff over! The sponsors have stopped paying for it.", "caption": "BUFF OVER! THE SPONSORS STOPPED PAYING." },
        { "text": "That's the last of the juice. Ordinary wizard, incoming.", "caption": "ORDINARY WIZARD, INCOMING." },
        { "text": "Perk expired! Try not to notice. The imps already have.", "caption": "PERK EXPIRED! THE IMPS ALREADY NOTICED." }
      ]
    },
    {
      "id": "cataclysm",
      "priority": 4,
      "cooldown": 0,
      "variants": [
        { "text": "CATACLYSM! That's gotta hurt! For the room!", "caption": "CATACLYSM! THAT'S GOTTA HURT! FOR THE ROOM!" },
        { "text": "The orb goes off! Everything else goes away!", "caption": "THE ORB GOES OFF! EVERYTHING ELSE GOES AWAY!" },
        { "text": "Cataclysm! One button, zero friends, maximum mop!", "caption": "ONE BUTTON, ZERO FRIENDS, MAXIMUM MOP!" },
        { "text": "BOOM! The whole room just applied for early retirement!", "caption": "THE WHOLE ROOM APPLIED FOR EARLY RETIREMENT!" },
        { "text": "Cataclysm Orb! That's not a spell, that's a complaint!", "caption": "THAT'S NOT A SPELL, THAT'S A COMPLAINT!" },
        { "text": "Room-wide boom! I felt that in the ratings!", "caption": "ROOM-WIDE BOOM! I FELT THAT IN THE RATINGS!" }
      ]
    },
    {
      "id": "commercial_back",
      "priority": 5,
      "cooldown": 0,
      "variants": [
        { "text": "And we're back!", "caption": "AND WE'RE BACK!" },
        { "text": "Back to the carnage!", "caption": "BACK TO THE CARNAGE!" },
        { "text": "Welcome back to the mayhem!", "caption": "WELCOME BACK TO THE MAYHEM!" },
        { "text": "Live again — wands up!", "caption": "LIVE AGAIN — WANDS UP!" },
        { "text": "We're live! Miss us?", "caption": "WE'RE LIVE! MISS US?" },
        { "text": "Back to the bloodsport!", "caption": "BACK TO THE BLOODSPORT!" }
      ]
    }
  ]
}
